<template>
  <div>
    <div class="row clearfix">
      <!-- <div style="text-align: right; margin-bottom : 10px;">
                    <button type="button" class="btn btn-default" @click="hideFormField(0)">뒤로</button>

                </div> -->

      <div class="col-lg-6 col-md-12 col-sm-12">
        <div class="body">
          <h2 class="card-inside-title">키 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="keys"
                  placeholder="키 추가"
                />
              </div>
            </div>
          </div>

          <h2 class="card-inside-title">라벨 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="label"
                  placeholder="라벨 추가"
                />
              </div>
            </div>
          </div>

          <h2 class="card-inside-title">도움말 (선택)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <textarea
                id="helpText"
                placeholder=""
                v-model="text"
                style="width: 100%; height: 80px"
              ></textarea>
            </div>
          </div>
          <h2 class="card-inside-title">타입 (선택)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <select class="form-control show-tick" v-model="types">
                <option value="">-- Please select --</option>
                <option value="string">String</option>
                <option value="password">Password</option>
              </select>
            </div>
          </div>

          <h2 class="card-inside-title">기본값 (선택)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="format"
                  placeholder="사용자에게 친근한 이름을 입력하세요"
                />
              </div>
            </div>
          </div>

          <h2 class="card-inside-title">옵션</h2>
          <div class="row clearfix">
            <div class="col-sm-12 form-group">
              <label class="c_checkbox">
                <input type="checkbox" v-model="required" />
                <span class="checkmark"></span>
                <span class="ml-2">&nbsp;필수</span>
              </label>
            </div>
            <div class="col-sm-12 form-group">
              <label class="c_checkbox">
                <input type="checkbox" v-model="multi" />
                <span class="checkmark"></span>
                <span class="ml-2">&nbsp;다중 허용</span>
              </label>
            </div>
<!--            <div class="col-sm-12 form-group">-->
<!--              <label class="c_checkbox">-->
<!--                <input type="checkbox" v-model="dynamic" />-->
<!--                <span class="checkmark"></span>-->
<!--                <span class="ml-2">&nbsp;다이나믹 필드 추가</span>-->
<!--              </label>-->
<!--            </div>-->
            <div class="col-sm-12 form-group">
              <label class="c_checkbox">
                <input
                  type="checkbox"
                  ref="dropdownChecked"
                  @change="dropdownTypeChecked"
                  v-model="dropdown"
                />
                <span class="checkmark"></span>
                <span class="ml-2">&nbsp;드롭다운</span>
              </label>
            </div>
          </div>

          <h2 class="card-inside-title" v-if="dropdownType">드롭다운 타입</h2>
          <div class="row clearfix" v-if="dropdownType">
            <div class="col-sm-12 form-group">
              <label class="c_radio">
                <input
                  type="radio"
                  name="dropdownRadio"
                  value="dynamic"
                  id=""
                  @change="dropdownSourceCheck(0)"
                  v-model="typeChecking"
                />
                <span class="checkmark"></span>
                <span class="ml-2">&nbsp;Dynamic</span>
              </label>
            </div>
            <div class="col-sm-12 form-group">
              <label class="c_radio">
                <input
                  type="radio"
                  name="dropdownRadio"
                  id=""
                  value="static"
                  @change="dropdownSourceCheck(1)"
                  v-model="typeChecking"
                  checked=""
                />
                <span class="checkmark"></span>
                <span class="ml-2">&nbsp;Static</span>
              </label>
            </div>
          </div>

          <h2 class="card-inside-title" v-if="dropdownType">드롭다운 소스</h2>
          <div class="row clearfix" v-if="dropdownType">
            <div class="col-sm-12" v-if="dropdownSourceDynamic">
              <select
                class="form-control show-tick"
                v-model="sourceData"
                @change="changeTrigSelectBox"
              >
                <option v-if="this.trigList.length == 0" value="">
                  트리거가 필요합니다.
                </option>
                <option
                  v-for="(list, index) in trigList"
                  v-bind:key="index"
                  :value="list.apiCode"
                >
                  {{ list.apiName }}
                </option>
              </select>
            </div>
            <div class="col-sm-12" v-if="dropdownSourceStatic">
              <div>
                <code>["Email","Name","Age"]</code> 이런 형태로 넣으시오
              </div>
              <textarea style="width: 100%;background: #2c2c2c;color: whitesmoke;resize: none;" v-model="codeSource"/>
<!--              <dev-code-mode v-bind:codeData="codeSource" />-->
            </div>
          </div>

          <h2 class="card-inside-title" v-if="!dynamicTrigSelected && typeChecking == 'dynamic' && this.trigList.length != 0">
            필드명 (필수)
          </h2>
          <div class="row clearfix" v-if="!dynamicTrigSelected && typeChecking == 'dynamic'  && this.trigList.length != 0">
            <div class="col-sm-12">
              <div class="form-group">
                <select
                  class="form-control show-tick"
                  v-model="fieldName"
                  v-if="outputList != null "
                >
                  <option v-if="outputList != null && outputList.length == 0"  value="">
                    트리거가 필요합니다.
                  </option>
                  <!-- <option>{{outputList.length}}</option> -->
                  <option  v-for="(list, index) in outputList" v-bind:key="index">
                    {{list.keys}}
                  </option>
                
                </select>
                <input
                  type="text"
                  class="form-control"
                  v-model="fieldName"
                  v-if="outputList == null"
                  placeholder="예시) id"
                />
              </div>
            </div>
          </div>

          <h2 class="card-inside-title" v-if="!dynamicTrigSelected && typeChecking == 'dynamic' && this.trigList.length != 0">
            필드 라벨 (선택)
          </h2>
          <div class="row clearfix" v-if="!dynamicTrigSelected && typeChecking == 'dynamic'  && this.trigList.length != 0">
            <div class="col-sm-12">
              <div class="form-group">
                <select
                class="form-control show-tick"
                v-model="fieldLabel"
                v-if="outputList != null"
              >
                <option v-if="outputList != null && outputList.length == 0" value="">
                  트리거가 필요합니다.
                </option>
                <option  v-for="(list, index) in outputList" v-bind:key="index">
                  {{list.keys}}
                </option>
                
              </select>
                <input
                  type="text"
                  class="form-control"
                  v-model="fieldLabel"
                  v-if="outputList == null"
                  placeholder="예시) Name"
                />
              </div>
            </div>
          </div>
        </div>
        <div style="text-align: right; margin-bottom: 10px">
          <button
            type="button"
            class="btn btn-primary"
            @click="hideFormField(1)"
          >
            저장
          </button>
          <button
            type="button"
            class="btn btn-default"
            @click="hideFormField(0)"
          >
            취소
          </button>
        </div>
      </div>

      <!-- <div class="col-lg-6 col-md-12 col-sm-12">
                    미리보기가 들어올 공간
                </div> -->
    </div>
    <!-- #END# Input -->
  </div>
</template>

<script>
// import DevCodeMode from "@/views/dev/tools/DevCodeMode.vue";

import eventbus from "@/store/modules/devEventBus";

export default {
  components: {
    // DevCodeMode: DevCodeMode,
  },
  methods: {
    hideFormField(num) {
      console.log("라벨:", this.label);

      if (num == 1) {
        if (this.keys == null || this.keys == "") {
          alert("키를 입력해주세요.");
          return;
        }

        if (this.label == null || this.label == "null" || this.label == "") {
          alert("라벨을 입력해주세요.");
          return;
        }

        if(this.dropdown){
           if((this.typeChecking.includes("dynamic") && this.searchSource == "") && (this.typeChecking.includes("static") && this.codeSource == null)){
          
            alert("드롭다운 소스는 필수항목 입니다.")
            return;
          
          } 
          if(this.typeChecking == "dynamic" && this.fieldName == null){
            alert("필드명은 필수 항목 입니다.")
            return;

          }
        }

        console.log(this.$store.state.devStore.formsData)

        var indexing = 0;
        if (this.$store.state.devStore.formsData.length == 0) {
          indexing = 0;
        } else {
          indexing = this.$route.params.fieldnum;
        }

        var check1 = 0;
        var check2 = 0;
        var check3 = 0;
        var check4 = 0;
        var check5 = new Map();

        if (this.required == true) {
          check1 = 1;
        }

        if (this.multi == true) {
          check2 = 1;
        }

        if (this.dynamic == true) {
          check3 = 1;
        }

        if (this.dropdown == true) {
          check4 = 1;

          console.log(this.typeChecking);
          console.log(check5);

          check5.set("type", this.typeChecking);
          if (this.sourceData != null) {
            check5.set("source", this.sourceData);
            var field = {
              fieldName: this.fieldName,
              fieldLabel: this.fieldLabel,
            };
            check5.set("field", field);
          }
          if (this.codeSource != null) {
            check5.set("codeSource", this.codeSource);
          }
        }

        var total = [
          check1,
          check2,
          check3,
          check4,
          Object.fromEntries(check5),
        ];

        console.log(indexing, total);

   
        var map = new Map();

        if (this.oldText == null) {
          if (this.keys != null && this.keys != "null" && this.keys != "") {
            map.set(this.keys, "{{bundle.inputData." + this.keys + "}}");
          }
        } else {
          if (this.keys != null && this.keys != "null" && this.keys != "") {
            map.set("oldText", this.oldText);
            map.set(this.keys, "{{bundle.inputData." + this.keys + "}}");
          }
        }



        var param = {
          appCode: this.$store.state.devStore.appCode,
          apiCode: this.$store.state.devStore.apiCode,

          checkType: "field",
          where: "input",

          index: indexing,
          keys: this.keys,
          label: this.label,
          types: this.types,
          field: this.field,
          description: this.text,
          format: this.format,

          checkboxs: JSON.stringify(total),

          apiSchema: JSON.stringify(Object.fromEntries(map)),
        };



        console.log("ㅔㅁㅇㄹㄴㄹㅇㄴ:" , param)

        this.api.configSchema(param)
          .then((res) => {
            console.log("저장 : ", res);


            this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
            .then((res)=>{

              this.$store.dispatch("apiDetail", {result : res}).then(()=>{

                this.$emit("hideField", -10);


              })

            })




          })
          .catch(() => alert("오류가 발생했습니다. auth fields"));
      } else {
        this.$emit("hideField", -10);
      }
    },
    dropdownTypeChecked() {
      console.log("checked dropdown");
      this.dropdownType = !this.dropdownType;
      this.dynamicTrigSelected = !this.dynamicTrigSelected
    },
    dropdownSourceCheck() {
      console.log(this.typeChecking);
      if (this.typeChecking == "dynamic") {
        this.dropdownSourceDynamic = true;
        this.dropdownSourceStatic = false;
      } else if (this.typeChecking == "static") {
        this.dropdownSourceDynamic = false;
        this.dropdownSourceStatic = true;
      }
    },
    changeTrigSelectBox() {
      console.log(this.sourceData != "");

      if (this.sourceData != "") {
        this.dynamicTrigSelected = false;


        //아웃풋에 등록되어 있는 값 긁어오기


      this.outputList = null

      for(var i = 0; i < this.$store.state.devStore.apiTrig.length; i++){
        
        console.log(this.$store.state.devStore.apiTrig[i])

        if(this.sourceData == this.$store.state.devStore.apiTrig[i].apiCode){
          console.log(JSON.parse(this.$store.state.devStore.apiTrig[i].apiSchema).define.mapping[0])
          if(JSON.parse(this.$store.state.devStore.apiTrig[i].apiSchema).define.mapping[0].keys != undefined){
            this.outputList = JSON.parse(this.$store.state.devStore.apiTrig[i].apiSchema).define.mapping

          }

        }
      }













      } else {
        this.dynamicTrigSelected = true;
      }
    },
  },

  data() {
    return {
      choice: "",
      typeChecking: "static",
      dropdownType: false,
      dropdownSourceDynamic: false,
      dropdownSourceStatic: true,

      dynamicTrigSelected: false,
      fieldName: "",
      fieldLabel: "",

      keys: null,
      label: null,
      types: null,
      text: null,
      format: null,

      required: false,
      multi: false,
      dynamic: false,
      dropdown: false,
      sourceData: "",
      codeSource: null,

      trigList: null,
      oldText: null,

      outputList : null,
    };
  },
  mounted() {
    console.log(
      "ddd mounted",
      this.$store.state.devStore.formsData,
      this.$route.params.fieldnum
    );

    if (this.$store.state.devStore.formsData.length > 0) {
      this.$store.state.devStore.apiSchema =
        this.$store.state.devStore.formsData[this.$route.params.fieldnum];
      // console.log(
      //   this.$store.state.devStore.apiSchema.multi.replace(/"/gi, "")
      // );


      this.keys = this.$store.state.devStore.apiSchema.keys.replace(/"/gi, "");
      this.oldText = this.$store.state.devStore.apiSchema.keys.replace(
        /"/gi,
        ""
      );
      this.label = this.$store.state.devStore.apiSchema.label.replace(
        /"/gi,
        ""
      );

      if (this.$store.state.devStore.apiSchema.type != "null") {
        this.types = this.$store.state.devStore.apiSchema.type.replace(
          /"/gi,
          ""
        );
      } else {
        this.types = "";
      }

      // console.log(this.$store.state.devStore.apiSchema.description == "null")
      if (this.$store.state.devStore.apiSchema.description != "null") {
        this.text = this.$store.state.devStore.apiSchema.description.replace(
          /"/gi,
          ""
        );
      } else {
        this.text = "";
      }

      if (this.$store.state.devStore.apiSchema.format != "null") {
        this.format = this.$store.state.devStore.apiSchema.format.replace(
          /"/gi,
          ""
        );
      } else {
        this.format = "";
      }

      if (
        this.$store.state.devStore.apiSchema.require.replace(/"/gi, "") == 0
      ) {
        this.required = false;
      } else {
        this.required = true;
      }

      console.log("key test :",this.$store.state.devStore.apiSchema.multi)
      if(this.$store.state.devStore.apiSchema.multi != undefined){
        if (this.$store.state.devStore.apiSchema.multi.replace(/"/gi, "") == 0) {
          this.multi = false;
        } else {
          this.multi = true;
        }
      } else {
        this.multi = true;
      }

      if (
        this.$store.state.devStore.apiSchema.dynamik.replace(/"/gi, "") == 0
      ) {
        this.dynamic = false;
      } else {
        this.dynamic = true;
      }

      if (
        this.$store.state.devStore.apiSchema.dropdown.replace(/"/gi, "") == 0
      ) {
        this.dropdown = false;
        this.dynamicTrigSelected = true;

      } else {
        this.dropdown = true;
        this.dynamicTrigSelected = true;

        var source = JSON.parse(
          this.$store.state.devStore.apiSchema.dropdownSource
        );
        console.log(source.type);

        this.typeChecking = source.type;
        this.dropdownSourceCheck();

        this.sourceData = source.source;
        this.codeSource = source.codeSource;

        console.log("소스코드:", source.codeSource);

        if (this.sourceData != "" && this.sourceData != null) {
          this.dynamicTrigSelected = true;

          this.fieldName = source.field.fieldName;
          this.fieldLabel = source.field.fieldLabel;

          console.log("필드네임",this.fieldName)
           //아웃풋에 등록되어 있는 값 긁어오기

           this.outputList = null


           for(var i = 0; i < this.$store.state.devStore.apiTrig.length; i++){
        
              console.log(this.$store.state.devStore.apiTrig[i])

              if(this.sourceData == this.$store.state.devStore.apiTrig[i].apiCode){
                console.log(Object.keys(JSON.parse(this.$store.state.devStore.apiTrig[i].apiSchema).define.mapping))
                if(JSON.parse(this.$store.state.devStore.apiTrig[i].apiSchema).define.mapping[0].keys != undefined){
                  this.outputList = JSON.parse(this.$store.state.devStore.apiTrig[i].apiSchema).define.mapping

                }

              }
            }
          


        }

        this.dropdownTypeChecked();
      }
    }
  },
  created() {
    eventbus.$on("codeData", (res) => {
      console.log(res);
      this.codeSource = res;
    });

    if (this.$store.state.devStore.apiTrig != null) {
      var list = [];
      for (var i = 0; i < this.$store.state.devStore.apiTrig.length; i++) {
        if (
          this.$store.state.devStore.apiTrig[i].apiCode !=
          this.$store.state.devStore.apiCode
        ) {
          list.push(this.$store.state.devStore.apiTrig[i]);
        }
      }

      console.log(list);
      this.trigList = list;
    }

    eventbus.$emit("fieldNum", 0);

 
  },
};
</script>
